module.exports = __webpack_public_path__ + "static/media/consultancy-header-bg.68e54993.png";